import "@openfonts/source-sans-pro_latin-ext";
import "@king-ict/eupisi-ui/styles/theme.scss";

import { StrictMode, Suspense } from "react";

import { keycloakInstance } from "@king-ict/eupisi-ui/auth";
import { ReactKeycloakProvider } from "@king-ict/eupisi-ui/components";
import { Spinner } from "@king-ict/eupisi-ui/components";
import { createBrowserHistory, History } from "history";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";

import App from "./app/App";
import { ai } from "./app/AppInsights";
import store from "./app/store";
import "./app/i18n";

const trackPageView = (history: History) => {
  history.listen((location) => {
    ai.trackPageView({ uri: location.pathname });
  });
};

const browserHistory = createBrowserHistory();

const AppWithTracking = () => {
  trackPageView(browserHistory);

  return (
    <Suspense fallback={<Spinner show={true} />}>
      <App />
    </Suspense>
  );
};

ReactDOM.render(
  <StrictMode>
    <ReactKeycloakProvider
      authClient={keycloakInstance}
      LoadingComponent={<Spinner show={true} />}
    >
      <Provider store={store}>
        <Router>
          <AppWithTracking />
        </Router>
      </Provider>
    </ReactKeycloakProvider>
  </StrictMode>,
  document.getElementById("root")
);
